import React, { createContext, useContext, useEffect } from 'react';

const ThemeContext = createContext();

const STORAGE_KEY = 'biztracker-theme';

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export const ThemeProvider = ({ children }) => {
  const theme = 'light';
  const setTheme = () => {};
  const toggleTheme = () => {};

  useEffect(() => {
    document.documentElement.classList.remove('dark');
    window.localStorage.setItem(STORAGE_KEY, 'light');
  }, []);

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
